// extracted by mini-css-extract-plugin
export default {"container":"GameFlowRoundHeading_container__GBVRw","line":"GameFlowRoundHeading_line__T7L15","roundHeading":"GameFlowRoundHeading_roundHeading__aS9Oi"};